import {
  BulkCapabilityRequest,
  BulkCapabilityRequestFilterObject,
  CapabilitiesScope,
} from 'types/capabilities/capabilities'

export const getWalletActionCapabilityRequestFilters = (walletLsid: string[]) => {
  if (!walletLsid?.length) return

  const walletFilters: BulkCapabilityRequestFilterObject[] = walletLsid?.map(walletLsid => {
    return {
      scope: CapabilitiesScope.WALLET,
      subjectId: walletLsid,
    }
  })

  return {
    capabilities: [
      {
        group: 'FIAT',
        name: 'WALLET_ACTIONS',
        objects: walletFilters,
      },
      {
        group: 'PAYMENT',
        name: 'INTERNAL',
        objects: walletFilters,
      },
    ],
  } as BulkCapabilityRequest
}

export const getAccountCapabilityRequestFilters = (accountReference: string) => {
  if (!accountReference) return

  const accountFilters: BulkCapabilityRequestFilterObject[] = [
    {
      scope: CapabilitiesScope.ACCOUNT,
      subjectId: accountReference,
    },
  ]

  return {
    capabilities: [
      {
        group: 'ACCOUNT',
        name: 'PRINCIPLE_CUSTOMER',
        objects: accountFilters,
      },
      {
        group: 'NETWORK',
        name: 'PARTICIPANT',
        objects: accountFilters,
      },
    ],
  } as BulkCapabilityRequest
}
